import { FormationOptions } from './formationOptions.model';
import { ExerciceSpecificContent } from './exerciceSpecificContent.model';
import { Session } from './session.model';
import { Student } from './student.model';
import { Language } from './language.model';
import { Teacher } from './teacher.model';
import { Site } from './site.model';
import { Staff } from './staff.model';
import { Recurrence } from './recurrence.model';
import { Progression } from './progression.model';
import { Event } from './event.model';
import { Company } from './company.model';

export class HoursByTeachers {
  teacher_id: number;
  teacher_detail: Teacher;
  nb_hours: number;
}

export class FormationList {
  id: number;
  hours_total: any;
  validity_period_from: Date;
  validity_period_to: Date;
}

export class Formation {
  id: number;
  url: string;
  updated_at: string;
  created_at: string;
  creation_channel?: string | null;
  name: string;
  mode_financement: string;
  status: string;
  hours_remaining: number;
  hours_total: any;
  validity_period_from: Date;
  validity_period_to: Date;
  start_from: Date;
  notes_to_teachers: string;
  notes_to_student: string;
  site: string;
  // site: Site;
  // responsable: Staff;
  sessions: Session[];
  student: Student;
  // student: string;
  manager: Staff;
  // language: string;
  language: string;
  language_detail: Language;
  teachers: Teacher[];
  active_teachers: Teacher[];
  recurrences?: Recurrence[];
  progression?: Progression;
  next_occurrence: string;
  next_session: Session;
  niveau: string;
  events: Event[];
  calendar: string;
  hours_to_plan: number;
  hours_planned: number;
  hours_consummed: number;
  hours_by_teachers: HoursByTeachers[];
  specific_content: ExerciceSpecificContent[];
  nb_report_by_student: number;
  booking_mode: string;
  mode_formation: string;
  trial_mode: boolean;
  is_stall: boolean;
  global_rate: string;
  options: FormationOptions[];
  sf_id: string;
  is_certificate_cdc_exported?: boolean;
  category_formation: string;
  formations_childs: FormationList[];
  parent: FormationList;
  type_formation: string;
  notes_from_teachers: string;
  last_sf_synced: Date;
  version: number;
  is_pro: boolean;
  has_been_planned: boolean;
  sf_invoice_id: string;
  edof_id: string;
  is_plan_limited_specific_content: boolean;
  price_hour: number;
  num_accord_opco: string;
  is_auto_expire: boolean;
  status_export_certificat_cdc: string;
  prolongation_reason: string;
  certification: any;
  organization: string;
  company: Company;
  csat: number;
  nps: number;
  token_poll: string;
  is_satisfaction_form_responded: boolean;
  token_certificate: string;
  lilate: string;
  certification_training: boolean;
  managed_service_type: string;

  percent_exercice_rate?: number;
  
  constructor() { }
}
